/** A draft is acknowledged only by a newer, persisted message from its sender. */
export function createSendConfirmations() {
  const pending = new Set();
  function finish(entry, error) {
    clearTimeout(entry.timer); pending.delete(entry);
    if (error) entry.reject(error); else entry.resolve(true);
  }
  return {
    wait(request, send) {
      return new Promise((resolve, reject) => {
        const entry = { ...request, resolve, reject };
        entry.timer = setTimeout(() => finish(entry, new Error("تأیید ارسال دریافت نشد؛ پیش‌نویس حفظ شد.")), 15000);
        pending.add(entry);
        try { send(); } catch (error) { finish(entry, error); }
      });
    },
    accept(rows) {
      if (!Array.isArray(rows)) return;
      for (const entry of pending) {
        if (rows.some((row) => Number(row.chatId) === Number(entry.id) && Number(row.id) > entry.beforeId
          && Number(row.userId) === Number(entry.currentUserId) && row.message === entry.text)) finish(entry);
      }
    },
    rejectAll() { for (const entry of pending) finish(entry, new Error("ارسال پیام تأیید نشد.")); },
  };
}
